/* eslint-disable max-len */
import React from 'react';

interface IEmailProps {
    color?: string;
}

const Email: React.FC<IEmailProps> = ({color='#899696'}) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_10421_176339)">
                <path
                    d="M10.9629 7.99967C10.9629 7.21385 10.6508 6.46021 10.0951 5.90454C9.53945 5.34888 8.78581 5.03671 7.99998 5.03671C7.21415 5.03671 6.46051 5.34888 5.90485 5.90454C5.34919 6.46021 5.03702 7.21385 5.03702 7.99967C5.03702 8.7855 5.34919 9.53914 5.90485 10.0948C6.46051 10.6505 7.21415 10.9626 7.99998 10.9626C8.78581 10.9626 9.53945 10.6505 10.0951 10.0948C10.6508 9.53914 10.9629 8.7855 10.9629 7.99967ZM10.9629 7.99967V9.11079C10.9629 9.60193 11.158 10.073 11.5053 10.4202C11.8526 10.7675 12.3237 10.9626 12.8148 10.9626C13.3059 10.9626 13.777 10.7675 14.1243 10.4202C14.4715 10.073 14.6666 9.60193 14.6666 9.11079V7.99967C14.6666 6.68113 14.2757 5.3922 13.5431 4.29587C12.8106 3.19955 11.7694 2.34506 10.5512 1.84048C9.33303 1.3359 7.99259 1.20387 6.69938 1.46111C5.40617 1.71834 4.21829 2.35328 3.28594 3.28563C2.35359 4.21798 1.71865 5.40587 1.46141 6.69907C1.20418 7.99228 1.3362 9.33272 1.84079 10.5509C2.34537 11.7691 3.19985 12.8103 4.29618 13.5428C5.39251 14.2753 6.68144 14.6663 7.99998 14.6663C9.1705 14.6675 10.3205 14.3598 11.3333 13.773"
                    stroke={color}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_10421_176339">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="matrix(-1 0 0 -1 16 16)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Email;